import { Repository } from '@/forms/api/repository-factory';
import getParams from '@/forms/helpers/get-params';

import { SEND_BANK_STATEMENT } from '@/forms/constants/services';
const resource = '/income/verification/statement/upload/v1.0';
// export default {
//   async sendBankStatement(payload, progressCallback) {
//     return Repository.post('/income/verification/statement/upload/v1.0', {
//       ...payload,
//     }, {
//       params: getParams(SEND_BANK_STATEMENT),
//       onUploadProgress: (progressEvent) => {
//         const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//         progressCallback(percentCompleted);
//       },
//     });
//   },
// };
export default {
  sendBankStatement(payload) {
    return Repository.post(`${resource}`, payload, {
      params: getParams(SEND_BANK_STATEMENT),
    });
  },
};
